import React, { FunctionComponent } from "react";
import TopShadow from "../TopShadow";

import "./Loading.scss";
import classNames from "classnames";

type Props = { isWithShadow?: boolean; className?: string };

const Loading: FunctionComponent<Props> = ({ isWithShadow, className }) => (
  <div className="loading">
    {isWithShadow && <TopShadow />}
    <div className={classNames("loading__spinner", className)} />
  </div>
);

export default Loading;
